<template>
    <div class="col-md-12">
        <pim-header @show-slot-content="handleFormState" :create-event="true" create-button-text="Create Scheduled Import" header="Scheduled Imports">
            <transition name="fade">
                <div v-if="form.open" class="form-horizontal throttle">
                    <div class="card panel panel-default actions">
                        <div class="card-block">
                            <div v-if="form.locked" class="text-center">
                                You must have at least one FTP-type channel to use this feature.
                            </div>
                            <div v-show="!form.locked">
                                <div class="row mt-3 pb-0">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="" class="">FTP Import Channel</label>
                                            <select style="width:100%;" class="form-control" v-model="form.scheduledImport.ftpImportChannelId">
                                                <option value="">Select</option>
                                                <template v-for="(channel, index) in this.form.channels">
                                                    <option :key="index" :value="channel.id">{{ channel.channel_name }}</option>
                                                </template>
                                            </select>
                                        </div>
                                        <div class="form-group">
                                            <label for="">FTP Credentials</label>
                                            <select style="width:100%;" class="form-control" v-model="form.scheduledImport.ftpCredentialId">
                                                <option value="">Select</option>
                                                <template v-for="(credential, index) in this.form.credentials">
                                                    <option :key="index" :value="credential.id">{{ credential.server }} -> {{credential.unarchived_path}}</option>
                                                </template>
                                            </select>
                                        </div>
                                        <div class="form-group">
                                            <label for="">Scheduled time</label>
                                            <template v-for="(time, index) in form.scheduledImport.scheduledTimes">
                                                <div class="form-group" :key="index">
                                                    <div class="input-group mb-3">
                                                        <input type="text" class="form-control" :value="time" disabled>
                                                        <div class="input-group-prepend">
                                                            <button class="btn btn-danger" type="button" @click="removeScheduledTime(index)">
                                                                <i class="fas fa-times"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                            <div class="input-group mb-3">
                                                <input id="scheduledDateTime" type="datetime-local" class="form-control" placeholder="Scheduled time" v-model="scheduledTime">
                                                <div class="input-group-prepend">
                                                    <button class="btn btn-primary" type="button" @click="addScheduledTime()">
                                                        <i class="fas fa-plus"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label for="">Frequency</label>
                                            <select style="width:100%;" class="form-control" v-model="form.scheduledImport.frequency">
                                                <option value="daily">Daily</option>
                                                <option value="weekly">Weekly</option>
                                                <option value="monthly">Monthly</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row pb-0">
                                    <div class="col-md-12 ml-auto">
                                        <button type="button" class="btn btn-primary" :disabled="!formState" @click.prevent="storeScheduledImport()">
                                            Save
                                        </button>
                                        <button type="button" class="btn btn-secondary">
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </pim-header>
        <product-alerts :status="alert" v-model="alert"></product-alerts>
        <div>
            <transition name="vue-table-loader">
                <div class="vue-table-loader" v-if="loading">
                    <span class="fa fa-cog fa-spin fa-3x"></span>
                </div>
            </transition>
            <div class="dataTables_wrapper container-fluid dt-bootstrap4 modern">
                <vuetable
                    ref="vuetable"
                    :api-url="gridUrl"
                    :fields="fields"
                    :css="css.table"
                    :per-page="perPage"
                    :sort-order="sortOrder"
                    :append-params="moreParams"
                    noDataTemplate="No Scheduled Imports Found"
                    pagination-path=""
                    @vuetable:pagination-data="onPaginationData"
                    @vuetable:loaded="onLoaded"
                >
                    <template slot="credential" slot-scope="props">
                        <div v-if="props.rowData.ftpcredential.archived">
                            <span>{{props.rowData.ftpcredential.server}} -> {{props.rowData.ftpcredential.unarchived_path}}</span>
                        </div>
                        <div v-else>
                            <span>{{props.rowData.ftpcredential.server}}</span>
                        </div>
                    </template>
                    <template slot="actions" slot-scope="props">
                        <div class="scheduled-imports__item-actions">
                            <button
                                class="btn btn-danger btn-actions"
                                @click.prevent="deleteScheduledImport(props.rowData.id)">
                                Delete
                            </button>
                        </div>
                    </template>
                </vuetable>
                <div class="row">
                    <div class="col-md-6">
                        <base-pagination-info
                            :css="css.table"
                            ref="paginationInfo"
                        >
                        </base-pagination-info>
                    </div>
                    <div class="col-md-6">
                        <base-pagination ref="pagination"
                             @vuetable-pagination:change-page="onChangePage"
                        ></base-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
    .scheduled-imports__item-actions {
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }
    .btn-actions {
        margin-right: 0.5rem;
    }
</style>
<script>
    import axios from 'axios';
    import moment from 'moment';

    import PimHeader from '../generic/pim-header';
    import ProductAlerts from '../products/product-details-alerts.vue';
    import BaseFilterBar from '../tables/base-filter-bar.vue';
    import BasePagination from '../tables/base-pagination.vue';
    import BasePaginationInfo from '../tables/base-pagination-info.vue';
    import BaseSelectVisible from '../tables/base-select-visible.vue';

    export default {
        name: 'scheduled-imports-index',
        components: {
            'base-filter-bar': BaseFilterBar,
            'base-pagination': BasePagination,
            'base-pagination-info': BasePaginationInfo,
            'base-select-visible': BaseSelectVisible,
            'pim-header': PimHeader,
            'product-alerts': ProductAlerts,
        },
        data() {
            return {
                alert: {
                    message: '',
                    status: 'alert-danger',
                    timeOut: 60000
                },
                form: {
                    open: false,
                    channels: [],
                    credentials:[],
                    locked: true,
                    formIsValid: false,
                    scheduledImport: {
                        ftpImportChannelId: '',
                        ftpCredentialId: '',
                        scheduledTimes: [],
                        frequency: 'daily'
                    },
                },
                scheduledTime: moment().add(1, 'hours').format('YYYY-MM-DD H:mm'),
                fields: [
                    {
                        name: 'channel.channel_name',
                        title: 'Channel',
                    },
                    {
                        name: '__slot:credential',
                        title: 'Credential',
                    },
                    {
                        name: 'frequency',
                        title: 'Frequency',
                    },
                    {
                        name: 'start_at',
                        title: 'Start at',
                        callback: this.formatDate,
                    },
                    {
                        name: "__slot:actions",
                        titleClass: "actions-single-column"
                    }
                ],
                perPage: 10,
                sortOrder: [
                    {
                        field: 'created_at',
                        direction: 'desc',
                    }
                ],
                moreParams: {},
                loading: true,
                amountsShown: [
                    { text: '10', value: 10 },
                    { text: '25', value: 25 },
                    { text: '50', value: 50 },
                    { text: '100', value: 100 }
                ],
                css: {
                    table: {
                        tableClass: 'table table-striped table-bordered table-middle',
                        ascendingIcon: 'sort-icon-asc',
                        descendingIcon: 'sort-icon-desc',
                        infoClass: '',
                    },
                },
            }
        },
        computed: {
            gridUrl() {
                return route('imports.scheduled.grid');
            },
            formState: function() {
                if (this.form.scheduledImport.ftpImportChannelId == '') {
                    return this.form.formIsValid = false;
                }

                if (this.scheduledTime == '' && this.form.scheduledImport.scheduledTimes.length < 1) {
                    return this.form.formIsValid = false;
                }

                if (this.form.scheduledImport.ftpCredentialId == '') {
                    return this.form.formIsValid = false;
                }

                return this.form.formIsValid = true;
            }
        },
        methods: {
            handleFormState(e) {
                this.form.open = !this.form.open;

                this.$nextTick(() => {
                    flatpickr('#scheduledDateTime', {
                        minDate: Date.now(),
                        enableTime: true
                    });
                });
            },
            validateDate(date) {
                return (new Date(date) < new Date());
            },
            addScheduledTime() {
                if (!this.scheduledTime) {
                    this.alert.message = 'You can\'t put an empty value.';
                    return;
                }

                if (this.validateDate(this.scheduledTime)) {
                    this.alert.message = 'You can\'t put an value before today.';
                    return;
                }

                this.form.scheduledImport.scheduledTimes.push(this.scheduledTime);
                this.scheduledTime = '';
            },
            removeScheduledTime(position) {
                this.form.scheduledImport.scheduledTimes.splice(position, 1);
            },
            deleteScheduledImport(id) {
                axios.delete(`${baseURL}/pimapi/scheduled-imports/${id}`).then(res => {
                    if (res.status == 204) {
                        this.alert.message = 'Scheduled import was deleted with success.';
                        this.alert.status = 'alert-success';
                        this.$nextTick(() => {
                            this.$refs.vuetable.refresh();
                        });
                    }
                });
            },
            clearAllFields() {
                this.form.formIsValid = false,
                this.form.locked = false,
                this.form.scheduledImport = {
                    ftpImportChannelId: '',
                    ftpCredentialId: '',
                    scheduledTimes: [],
                    frequency: 'daily'
                },
                this.scheduledTime = ''
            },
            storeScheduledImport() {
                if (this.scheduledTime != '') {
                    this.addScheduledTime();
                }

                axios.post(`${baseURL}/pimapi/scheduled-imports/store`, this.form.scheduledImport).then(res => {
                    if (res.status == 201) {
                        this.clearAllFields();
                        this.alert.message = 'Scheduled import created with success.';
                        this.alert.status = 'alert-success';
                        this.$nextTick(() => {
                            this.$refs.vuetable.refresh();
                        });
                    }
                });
            },
            formatDate (value) {
                if (value === null) {
                    return 'Never';
                }
                return moment(value).format("MMM Do YY [at] LT");
            },
            onPaginationData (paginationData) {
                this.$refs.pagination.setPaginationData(paginationData)
                this.$refs.paginationInfo.setPaginationData(paginationData)
            },
            onChangePage (page) {
                this.$refs.vuetable.changePage(page)
            },
            doVisibleSet (perPageValue) {
                this.perPage = perPageValue;
                this.$nextTick( () => this.$refs.vuetable.refresh())
            },
            onFilterSet (filterText) {
                this.moreParams = {
                    'filter': filterText
                }
                this.$nextTick( () => this.$refs.vuetable.refresh())
            },
            onFilterReset () {
                this.moreParams = {}
                this.$nextTick( () => this.$refs.vuetable.refresh())
            },
            onLoaded: function () {
                this.loading = false;
            },
            hand(value) {
                console.log(value)
            }
        },
        mounted() {
            this.$events.$on('per-page', eventData => this.doVisibleSet(eventData))
            this.$events.$on('filter-set', eventData => this.onFilterSet(eventData))
            this.$events.$on('filter-reset', e => this.onFilterReset())

            axios.get(`${baseURL}/pimapi/channel-types/ftp-import/channels`).then(res => {
                if (res.data.length > 0) {
                    this.form.channels = res.data;
                    this.form.locked = false;
                }
            });

            axios.get(`${baseURL}/ftp_credentials`).then(res => {
                if (res.data.length > 0) {
                    this.form.credentials = res.data;
                    this.form.locked = false;
                }
            });
        },
        watch: {
            perPage() {
                this.$nextTick(function() {
                    this.$refs.vuetable.refresh()
                })
            },
            scheduledTime(e) {
                console.log(e);
            }
        },
    }
</script>
